export default "__VITE_ASSET__DyCRZN4q__"